module.exports = __webpack_public_path__ + "static/img/半身照示例.5f2b901.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/assets/半身照示例.jpg
// module id = K4bC
// module chunks = 1